import React, { useState, useEffect } from 'react';
import Barcode from 'react-barcode';

/**
 * Componente que genera una etiqueta con código de barras.
 *
 * @param {number} [alto] - Alto de la hoja, valor por defecto 1200.
 * @param {number} [alto_etiqueta] - Alto de la etiqueta.
 * @param {number} [ancho_etiqueta] - Ancho de la etiqueta.
 * @param {Object} [data] - Registro de tarea para mostrar. debe contener los siguientes campos: {id, bloque, plan_cosecha_id, asignado_a_id, asignado_a, asignado_por_id, asignado_por, fecha_asignacion, fecha_realizado, dia, impreso, semana, trasplante, cosecha}.
 * @param {boolean} [imprimir] - Indica si se debe imprimir el código de barras, si no se manda en verdadero se usará un codigo invalido en la etiqueta para evitar mal uso en la previsualización.
 * @param {number} [index] - Índice de la etiqueta.
 * @param {number} [interno] - Ancho interno del componente.
 * @param {number} [externo] - Ancho externo del componente.
 * @returns {JSX.Element} Componente de etiqueta con código de barras.
 */
const EtiquetaBarcode = (p) => {
    const altoHoja = p.alto ?? 1200;
    const altoEtiqueta = p.alto_etiqueta ?? (altoHoja / 21.71875) - (0.28);
    const anchoEtiqueta = p.ancho_etiqueta ?? (altoHoja * 0.773 / 4.788) - 1;
    const styleEtiqueta = { width: `${anchoEtiqueta}px`, height: `${altoEtiqueta}px` };

    const data = p.data ?? {
        "id": -1,
        "bloque": "NO RECIBIDO",
        "plan_cosecha_id": -1,
        "asignado_a_id": -1,
        "asignado_a": "NO ENCONTRADO",
        "asignado_por_id": -1,
        "asignado_por": "NO ENCONTRADO",
        "fecha_asignacion": null,
        "fecha_realizado": null,
        "dia": -1,
        "impreso": "NO ENCONTRADO",
        "semana": "-",
        "trasplante": "-",
        "cosecha": "-",
    };

    const codeShow = `${p.imprimir ? data.id : -75}`;

    return (
        <>
            <div
                className='text-center bg-white contenedor rounded m-0 p-0 border round-xs d-flex justify-content-center align-items-center'
                style={{ marginTop: '0px', marginBottom: '5px', lineHeight: '1.05', ...styleEtiqueta }}>
                <div className='row d-flex w-100 justify-content-center m-0 p-0' >
                    <div className='w-100 m-0 p-0 text-xs text-bold'>
                        {data.semana}-{data.dia + 1}/{data.trasplante}/{data.cosecha}<span className='ps-1 text-xxs'>{data.asignado_a}</span>
                    </div>
                    <div className='w-100 m-0 p-0 text-xs text-bold'>{data.bloque}</div>
                    <div className='col-auto text-center p-0' style={{ marginTop: '7px', marginBottom: '0' }}>
                        <Barcode value={codeShow} width={1} height={10} margin={0} displayValue={false} />
                    </div>
                </div>
            </div>

            {p.index !== undefined && p.interno && p.externo && p.index < 3 &&
                <div className="m-0 p-0" style={{ maxWidth: `${p.interno}px`, minWidth: `${p.interno}px` }}></div>
            }
        </>
    )
}

export default EtiquetaBarcode;